module.exports = __webpack_public_path__ + "img/card-book-transfer.b69b27e5.svg";